import React from 'react';

import { ReleaseNoteSection } from '.';
import { releaseNotesContent } from './releaseNotesContent';

/**
 * Renders the data from ./release_notes.json as formatted HTML.
 */
export const ReleaseNotes = (): JSX.Element => (
    <div>
        <h1>Release Notes</h1>
        {releaseNotesContent.map(
            (note: ReleaseNote): JSX.Element => (
                <div className="mt-4 mb-10" key={note.version}>
                    <h2>Version {note.version}</h2>
                    <p>{note.date}</p>
                    {note.new && (
                        <ReleaseNoteSection
                            header="What's New"
                            items={note.new}
                        />
                    )}
                    {note.fixes && (
                        <ReleaseNoteSection
                            header="Bug Fixes"
                            items={note.fixes}
                        />
                    )}
                </div>
            ),
        )}
    </div>
);
